import { render, staticRenderFns } from "./shopListSetting.vue?vue&type=template&id=cb26d93a&scoped=true"
import script from "./shopListSetting.vue?vue&type=script&lang=js"
export * from "./shopListSetting.vue?vue&type=script&lang=js"
import style0 from "./shopListSetting.vue?vue&type=style&index=0&id=cb26d93a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb26d93a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cb26d93a')) {
      api.createRecord('cb26d93a', component.options)
    } else {
      api.reload('cb26d93a', component.options)
    }
    module.hot.accept("./shopListSetting.vue?vue&type=template&id=cb26d93a&scoped=true", function () {
      api.rerender('cb26d93a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/operationManagement/customPage/components/shopListSetting.vue"
export default component.exports